"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormElementWrapper = _interopRequireDefault(require("./FormElementWrapper"));

var _excluded = ["input", "label", "meta", "liveSaver", "tooltip", "options"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioBox = function RadioBox(props) {
  var input = props.input,
      label = props.label,
      meta = props.meta,
      liveSaver = props.liveSaver,
      tooltip = props.tooltip,
      options = props.options,
      rest = _objectWithoutProperties(props, _excluded);

  var getRadio = function getRadio(_ref) {
    var id = _ref.id,
        name = _ref.name;

    var handleChange = function handleChange() {
      input.onChange(id);
    };

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "radio"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "custom-radio",
      type: "radio",
      id: "radio-".concat(id),
      name: input.name,
      value: id,
      onChange: handleChange
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "radio-".concat(id)
    }, name));
  };

  return /*#__PURE__*/_react["default"].createElement(_FormElementWrapper["default"], {
    tooltip: tooltip,
    meta: meta,
    label: label,
    liveSaver: liveSaver
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "group-radio"
  }, options && options.map(getRadio)));
};

RadioBox.displayName = 'Radio';
RadioBox.propTypes = {
  input: _propTypes["default"].object,
  label: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  liveSaver: _propTypes["default"].object,
  tooltip: _propTypes["default"].string,
  options: _propTypes["default"].array
};
var _default = RadioBox;
exports["default"] = _default;